import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";


import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import ThemeColorPicker from "../../Components/Common/ColorPicker";
import { getAllPartnerById, updatePartnerColorById } from "../../api/axios";
import styled from "styled-components";
import CmsCircularProgress from "../../Components/Common/CircularProgress";
import { showToast } from '../../Utills/toast';
import infoIcon from "../../Assets/info.svg";
import themeInfo from "../../Assets/themeinfo.png";


const Grid = styled.div`
grid-template-columns: repeat(3, minmax(0, 1fr));
gap: 0.75rem;
display: grid;
@media (max-width: 1250px) {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
 @media (max-width: 590px) {
  grid-template-columns: repeat(1, minmax(0, 1fr));
 }
`;
const ButtonGroup = styled.div`
display: flex;
justify-content: end;
gap: 16px;
padding-top: 20px;
button {
  width: auto;
}
`;


const ThemeSetting = () => {
  const [loading, setLoading] = useState(false);
  const [formValues, setFormValues] = useState({});
  const { partnerId } = useParams();
  const [partnerData, setPartnerData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [infoOpen, setInfoOpen] = useState(false);

  // useEffect hook to fetch the ID from the API

  useEffect(() => {
    setIsLoading(true);
    if (!Number(partnerId)) {
      setIsLoading(false);
      return
    };
    getAllPartnerByIdData();
  }, [partnerId]);

  const getAllPartnerByIdData = async () => {
    try {
      const response = await getAllPartnerById(partnerId);
      // const data = await response.json();
      if (response.data.data.length > 0) {
        setPartnerData(response.data.data[0]);
        console.log(response.data.data[0]);
      } else {
        console.log(response.message);
      }
    } catch (error) {
      console.log(error);
    }finally{
      setIsLoading(false);
    };
  };

  useEffect(() => {
    if (partnerData) {
      console.log("partnerData: ", partnerData);
      setFormValues({
        logo: partnerData?.logo,
        primary_color:
          (partnerData?.primary_color !== "null" &&
            partnerData.primary_color) ||
          "#84ceeb",
        tertiary_color:
          (partnerData?.tertiary_color !== "null" &&
            partnerData.tertiary_color) ||
          "#5680e9",
        secondary_color:
          (partnerData?.secondary_color !== "null" &&
            partnerData.secondary_color) ||
          "#c1c8e4",
        header_background_color:
          (partnerData?.header_background_color !== "null" &&
            partnerData?.header_background_color) ||
          "#fc8433",
        header_text_color:
          (partnerData?.header_text_color !== "null" &&
            partnerData?.header_text_color) ||
          "#ffffff",
        legado_protect_background_color:
          (partnerData?.legado_protect_background_color !== "null" &&
            partnerData?.legado_protect_background_color) ||
          "#f7eee7",
        legado_protect_text_color:
          (partnerData?.legado_protect_text_color !== "null" &&
            partnerData?.legado_protect_text_color) ||
          "#000000",
        // global_pet_industry_background_color:
        //   (partnerData?.global_pet_industry_background_color !== "null" &&
        //     partnerData?.global_pet_industry_background_color) ||
        //   "#FFFFFF",
        // global_pet_industry_text_color:
        //   (partnerData?.global_pet_industry_text_color !== "null" &&
        //     partnerData?.global_pet_industry_text_color) ||
        //   "#ffffff",
        // pawprintid_works_card_background_color:
        //   (partnerData?.pawprintid_works_card_background_color !== "null" &&
        //     partnerData?.pawprintid_works_card_background_color) ||
        //   "#fc8433",
        footer_background_color:
          (partnerData?.footer_background_color !== "null" &&
            partnerData?.footer_background_color) ||
          "#fc8433",
        footer_text_color:
          (partnerData?.footer_text_color !== "null" &&
            partnerData?.footer_text_color) ||
          "#ffffff",
      });
    }
  }, [partnerData]);

  const handleInputChange = (name, value) => {
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleReset = () => {
    setFormValues({
      logo: partnerData?.logo,
      primary_color:
        (partnerData?.primary_color !== "null" && partnerData?.primary_color) ||
        "#84ceeb",
      tertiary_color:
        (partnerData?.tertiary_color !== "null" &&
          partnerData?.tertiary_color) ||
        "#5680e9",
      secondary_color:
        (partnerData?.secondary_color !== "null" &&
          partnerData?.secondary_color) ||
        "#c1c8e4",
      header_background_color:
        (partnerData?.header_background_color !== "null" &&
          partnerData?.header_background_color) ||
        "#fc8433",
      header_text_color:
        (partnerData?.header_text_color !== "null" &&
          partnerData?.header_text_color) ||
        "#FFFFFF",
        legado_protect_background_color:
        (partnerData?.legado_protect_background_color !== "null" &&
          partnerData?.legado_protect_background_color) ||
        "#f7eee7",
      legado_protect_text_color:
        (partnerData?.legado_protect_text_color !== "null" &&
          partnerData?.legado_protect_text_color) ||
        "#ffffff",
      // global_pet_industry_background_color:
      //   (partnerData?.global_pet_industry_background_color !== "null" &&
      //     partnerData?.global_pet_industry_background_color) ||
      //   "#fc8433",
      // global_pet_industry_text_color:
      //   (partnerData?.global_pet_industry_text_color !== "null" &&
      //     partnerData?.global_pet_industry_text_color) ||
      //   "#ffffff",
      // pawprintid_works_card_background_color:
      //   (partnerData?.pawprintid_works_card_background_color !== "null" &&
      //     partnerData?.pawprintid_works_card_background_color) ||
      //   "#fc8433",
      footer_background_color:
        (partnerData?.footer_background_color !== "null" &&
          partnerData?.footer_background_color) ||
        "#fc8433",
      footer_text_color:
        (partnerData?.footer_text_color !== "null" &&
          partnerData?.footer_text_color) ||
        "#ffffff",
    });
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const formData = new FormData();
      const dataToSend = { ...formValues, id: partnerId };

      for (const [key, value] of Object.entries(dataToSend)) {
        formData.append(key, value);
      }

      try {
        const response = await updatePartnerColorById(partnerId, formData);
        showToast({
          type: 'success',
          message: 'Theme settings updated successfully!',
        });
        console.log(response.data);
      } catch (error) {
        showToast({
          type: 'error',
          message: 'Failed to update theme settings. Please try again.',
        });
        console.error(error);
      }
    } catch (error) {
      showToast({
        type: 'error',
        message: 'An unexpected error occurred. Please try again.',
      });
    } finally {
      setLoading(false);
    }
  };

  
  return (
    <>
    {isLoading ? <CmsCircularProgress/> : 
    <div>
      <form
        className="p-md-4 p-sm-3 p-2 shadow-md rounded-md"
        onSubmit={(e) => e.preventDefault()}
      >
         <div className="d-flex gap-2">
          <h2 className="mb-md-3 mb-sm-2 mb-1 fs-3">Theme Settings</h2>
          <div className="mt-1" style={{ cursor: 'pointer' }} onClick={() => setInfoOpen(true)}>
            <img src={infoIcon} alt="info" height={'16px'} width={'16px'}/>
          </div>
        </div>
        <Dialog open={infoOpen} onClose={() => setInfoOpen(false)} maxWidth="md" fullWidth>
          <DialogTitle>
            Theme Settings Infomation
          </DialogTitle>
          <DialogContent dividers>
              <div className="border rounded">
              <img src={themeInfo} alt="themeInfo" height={'100%'} width={'100%'} className="rounded"/>
              </div>
          </DialogContent>
          <DialogActions className="w-auto">
            <Button onClick={() => setInfoOpen(false)} color="primary" variant="contained" className="w-auto">
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <Grid>
          {/* <TextField
              label="Primary Color"
              type="text"
              value={formValues.primary_color || ''}
              onChange={(e) => handleInputChange('primary_color', e.target.value)}
              fullWidth
              margin="dense"
            /> */}
         <div>
         <label className="mb-1 fw-normal">Primary color</label>
         <ThemeColorPicker
            name="primary_color"
            value={formValues.primary_color}
            onChange={(newColor) =>
              handleInputChange("primary_color", newColor)
            }
          />
         </div>
          {/* <TextField
              label="Secondary Color"
              type="text"
              value={formValues.secondary_color || ''}
              onChange={(e) => handleInputChange('secondary_color', e.target.value)}
              fullWidth
              margin="dense"
            /> */}
          <div> 
            <label className="mb-1 fw-normal">Secondary color</label>
            <ThemeColorPicker
              name="secondary_color"
              value={formValues.secondary_color}
            onChange={(newColor) =>
              handleInputChange("secondary_color", newColor)
            }
          />
        </div>
          {/* <TextField
              label="Tertiary Color"
              type="text"
              value={formValues.tertiary_color || ''}
              onChange={(e) => handleInputChange('tertiary_color', e.target.value)}
              fullWidth
              margin="dense"
            /> */}
          <div>
            <label className="mb-1 fw-normal">Tertiary color</label>
            <ThemeColorPicker
              name="tertiary_color"
              value={formValues.tertiary_color}
            onChange={(newColor) =>
              handleInputChange("tertiary_color", newColor)
            }
          />
        </div>
        <div>
            <label className="mb-1 fw-normal">Header background color</label>
            <ThemeColorPicker
              name="header_background_color"
              value={formValues.header_background_color}
            onChange={(newColor) =>
              handleInputChange("header_background_color", newColor)
            }
          />
        </div>
        <div>
            <label className="mb-1 fw-normal">Header text color</label>
            <ThemeColorPicker
              name="header_text_color"
              value={formValues.header_text_color}
            onChange={(newColor) =>
              handleInputChange("header_text_color", newColor)
            }
          />
        </div>
        <div>
          <label className="mb-1 fw-normal">Legado Protect background Color</label>
          <ThemeColorPicker
            name="legado_protect_background_color"
            value={formValues.legado_protect_background_color            }
            onChange={(newColor) =>
              handleInputChange("legado_protect_background_color", newColor)
            }
          />
        </div>
        <div>
          <label className="mb-1 fw-normal">Legado Protect text Color</label>
          <ThemeColorPicker
            name="legado_protect_text_color"
            value={formValues.legado_protect_text_color}
            onChange={(newColor) =>
              handleInputChange("legado_protect_text_color", newColor)
            }
          />
        </div>
        {/* <div>
            <label className="mb-1 fw-normal">Global pet industry background Color</label>
            <ThemeColorPicker
              name="global_pet_industry_background_color"
              value={formValues.global_pet_industry_background_color}
            onChange={(newColor) =>
              handleInputChange("global_pet_industry_background_color", newColor)
            }
          />
        </div> */}
        {/* <div>
            <label className="mb-1 fw-normal">Global pet industry text Color</label>
            <ThemeColorPicker
              name="global_pet_industry_text_color"
              value={formValues.global_pet_industry_text_color}
            onChange={(newColor) =>
              handleInputChange("global_pet_industry_text_color", newColor)
            }
          />
        </div> */}
        {/* <div>
            <label className="mb-1 fw-normal">Pawprintid works card background Color</label>
            <ThemeColorPicker
              name="pawprintid_works_card_background_color"
              value={formValues.pawprintid_works_card_background_color}
            onChange={(newColor) =>
              handleInputChange("pawprintid_works_card_background_color", newColor)
            }
          />
          </div> */}
        <div>
          <label className="mb-1 fw-normal">Footer background color</label>
          <ThemeColorPicker
            name="footer_background_color"
            value={formValues.footer_background_color}
            onChange={(newColor) =>
              handleInputChange("footer_background_color", newColor)
            }
          />
        </div>
        <div>
          <label className="mb-1 fw-normal">Footer text color</label>
          <ThemeColorPicker
            name="footer_text_color"
            value={formValues.footer_text_color}
            onChange={(newColor) =>
              handleInputChange("footer_text_color", newColor)
            }
          />
        </div>
        </Grid> 
        <ButtonGroup>
          <Button onClick={handleReset} variant="contained" color="error">
            Reset
          </Button>
          <Button
            onClick={handleSubmit}
            variant="contained"
            color="primary"
            disabled={loading}
          >
            {loading ? <CircularProgress size={20} /> : "Save"}
          </Button>
        </ButtonGroup>
      </form>    
    </div>}
    </>
  );
};

export default ThemeSetting;
